import React from 'react'

import {getClosestDataIdToEventTarget} from '@vio/core/src/_web/utils/browser'
import {useDispatchTeamEvent} from '@vio/core/src/analytics/components/TeamContext'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'

type PropsTypes = {
  children: React.ReactNode
  onClick: () => void
  className?: string
}

export enum SelectedElement {
  StaticMap = 'StaticMap',
  StaticMapBackground = 'StaticMapBackground',
  MapButton = 'MapButton',
  CompleteAddress = 'CompleteAddress'
}

export const TrackLocationClick = ({
  children,
  onClick,
  className
}: PropsTypes) => {
  const dispatchTeamEvent = useDispatchTeamEvent()

  const trackLocationClick = (selectedElement: string) => {
    dispatchTeamEvent(
      trackEvent({
        category: Category.User,
        action: Action.Clicked,
        entity: Entity.HotelDetailsLocationSection,
        payload: {
          selectedElement
        }
      })
    )
  }

  const handleKeyUp = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      trackLocationClick(SelectedElement.StaticMap)
      onClick()
      e.preventDefault()
    }
  }

  const handleClick = (e: React.MouseEvent) => {
    trackLocationClick(getClosestDataIdToEventTarget(e))
    onClick()
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onKeyUp={handleKeyUp}
      onClick={handleClick}
      className={className}
    >
      {children}
    </div>
  )
}
